import React, { Fragment } from "react"
import MenuSchema from "../../../components/menu-schema"

const MyChildren = ({ name, price, description }) => {
  //menu schema
  const menuSchema = {
    "@context": "https://schema.org",
    "@type": "Menu",
    name: "RibsUSABBQ Menu",
    mainEntityOfPage: "https://ribsusabbq.com/full-menu/",
    inLanguage: "English",
    hasMenuSection: [
      {
        "@type": "MenuSection",
        name: "RibsUSABBQ Menu",
        hasMenuItem: {
          "@type": "MenuItem",
          name: name,
          description: description,
          offers: [
            {
              "@type": "Offer",
              price: price,
              priceCurrency: "USD",
            },
          ],
        },
      },
    ],
  }
  return (
    <Fragment>
      <MenuSchema menuSchema={menuSchema} />
      <div className="inline-block mr-4">
        <span className="item-name">{name}</span>
        {price === 0 ? null : (
          <span className="float-right item-price">{`$${price}`}</span>
        )}

        {description ? <p className="item-des">{description}</p> : null}
      </div>
    </Fragment>
  )
}

export default MyChildren
